<span [matMenuTriggerFor]="menu"></span>

<ng-container>
  <mat-menu #menu="matMenu">
    <div class="menu-wrapper" (click)="click($event)">
      <loader [loading]="getAbsenceGetRequest?.loading$"></loader>

      <ng-container *ngFor="let absenceData of absences">
        <div [class.border-bottom]="showActionButtons">
          <div class="absence-data-row">
            <span
              class="absence-circle absence-data-item"
              [ngClass]="{
                vacansy: absenceData?.is_vacation,
                absence: !absenceData?.is_vacation
              }">
            </span>
            {{ (absenceData?.is_vacation === 1 ? 'Vacation' : 'Absence') | translate }}
          </div>

          <div class="absence-data-row__smaller">
            <span class="absence-data-item" translate>Period:</span>
            {{ absenceData?.from | formatDate: 'DD.MM.YYYY' }} - {{ absenceData?.to | formatDate: 'DD.MM.YYYY' }}
            <span *ngIf="absenceData.formattedDuration">({{ absenceData.formattedDuration }})</span>
            <span *ngIf="!absenceData.formattedDuration"
              >({{ absenceData.working_days }} {{ absenceData.working_days === 1 ? 'day' : ('days' | translate) }})</span
            >
          </div>

          <div class="absence-data-row__smaller">
            <span class="absence-data-item" translate>Status:</span>
            {{ absenceData?.status | titlecase | translate }}
          </div>

          <div class="absence-data-row__smaller" *ngIf="absenceData?.absenceType">
            <span class="absence-data-item" translate>Absence Type:</span>
            {{ absenceData?.absenceType?.name | titlecase | translate }}
          </div>

          <div class="absence-data-row__smaller text-ellipsis">
            <span class="absence-data-item" translate>Comment: </span>
            <span [matTooltip]="absenceData?.comment">{{
              absenceData?.comment ? absenceData?.comment : ('None' | translate)
            }}</span>
          </div>

          <div *ngIf="showActionButtons" class="absence-control-row">
            <ng-container *ngIf="absenceData?.status === requestStatuses.New || canUpdate()">
              <btn-action
                styleClasses="edit"
                iconClass="icon-Edit_ico"
                [withIcon]="true"
                [buttonLabel]="'Edit' | translate"
                (applyAction)="editAbsence(absenceData)">
              </btn-action>
            </ng-container>

            <ng-container *ngIf="absenceData?.status === requestStatuses.New || canDelete()">
              <button class="action-item__delete" (click)="deleteAbsence(absenceData)">
                <span class="icon-wrap">
                  <i class="icon action-icon icon-Delete_ico" [matTooltip]="'Delete' | translate"></i>
                </span>
              </button>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </div>
  </mat-menu>
</ng-container>
